export const toolsList = [
  {
    id: 1,
    title: "Image Compressor Pro",
    description: "Compress PNG, JPEG, and WebP images instantly with this 100% free & easy-to-use online tool!",
    path: "/tools/image-reducer",
    icon: <i className="la la-image tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
    category: "productivity"
  },
  {
    id: 2,
    title: "PDF Merger",
    description: "Merge multiple PDF files into a single document easily. Upload up to 5 files, arrange them in your desired order, and combine with one click.",
    path: "/tools/pdf-merger",
    icon: <i className="la la-file-pdf tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
    category: "productivity"
  },
  // {
  //   id: 3,
  //   title: "Video Converter",
  //   description: "Convert videos between MP4, MOV, AVI, MKV and more formats. Change video quality and download in your preferred format.",
  //   path: "/tools/video-converter",
  //   icon: <i className="la la-video tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
  //   category: "productivity"
  // },
  {
    id: 4,
    title: "Resume Templates",
    description: "Browse and download professional resume templates designed for various industries and career levels.",
    path: "/tools/resume-templates",
    icon: <i className="la la-file-text tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
    category: "resume"
  },
  {
    id: 5,
    title: "AI Resume Builder",
    description: "Create a professional resume with AI assistance. Get suggestions for content and formatting to make your resume stand out.",
    path: "/tools/resume-builder",
    icon: <i className="la la-file-contract tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
    category: "resume"
  },
  // {
  //   id: 6,
  //   title: "AI Resume Analyzer",
  //   description: "Check if your resume is ATS Compliant. Get insights and suggestions to improve your resume's visibility to recruiters.",
  //   path: "/tools/resume-analyzer",
  //   icon: <i className="la la-search tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
  //   category: "resume"
  // },
  {
    id: 7,
    title: "Application Forms",
    description: "Student application forms for Lahore Garrison University. Easy to fill and submit online.",
    path: "/tools/application-forms",
    icon: <i className="la la-clipboard-list tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
    category: "university"
  },
  // {
  //   id: 8,
  //   title: "FYP Project Ideas",
  //   description: "Browse through innovative final year project ideas across different domains and technologies.",
  //   path: "/tools/fyp-ideas",
  //   icon: <i className="la la-lightbulb tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
  //   category: "university"
  // },
  // {
  //   id: 9,
  //   title: "Old FYP Projects",
  //   description: "Access existing final year projects with code and documentation. Learn from previous projects to improve your own.",
  //   path: "/tools/old-fyp-projects",
  //   icon: <i className="la la-book-open tool-icon-svg" style={{ fontSize: '48px' }} aria-hidden="true"></i>,
  //   category: "university"
  // }
];
